import React, {useEffect, useState} from 'react';
import {TableCell} from "../../../TableWithDraggableRows/TableWithDraggableRows";
import moment from "moment";
import useInterval from "../../../Utils/UseInterval";

function isToday(someDate) {
    const today = new Date()
    return someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear()
}

export default function ArrivalTimeCell({index, route, row, isDragging, provided, snapshot}) {
    const [arrivalTimeFromNowText, setArrivalTimeFromNowText] = useState(null);
    const [arrivalTimeText, setArrivalTimeText] = useState(null);

    function updateArrivalTimeHumanized(finishTimeMoment) {
        setArrivalTimeFromNowText(finishTimeMoment.fromNow());
    }

    function updateArrivalTimeText(finishTimeMoment) {
        const arrivalTimeTextFormat = isToday(finishTimeMoment.toDate()) ? 'HH:mm' : 'HH:mm DD/MM/YYYY';
        setArrivalTimeText(finishTimeMoment.format(arrivalTimeTextFormat));
    }

    useEffect(() => {
        let finishTimeMoment;

        if (row.real_time_finish_time)
            finishTimeMoment = moment(new Date(row.real_time_finish_time));
        else
            finishTimeMoment = moment(new Date(new Date(route.timestamp).getTime() + row.duration * 1000));

        updateArrivalTimeText(finishTimeMoment);
        updateArrivalTimeHumanized(finishTimeMoment);
    }, [row, route]);

    useInterval(() => {
        if (row.real_time_finish_time) {
            const realTimeFinishTimeMoment = moment(new Date(row.real_time_finish_time));
            updateArrivalTimeHumanized(realTimeFinishTimeMoment);
        }
    }, 5000);

    return (
        <TableCell
            isDragOccurring={isDragging}
            isDragging={snapshot.isDragging}
            cellId="arrival-time"
            className="cell"
            key={`row-${row.order_id}-cell-arrival-time`}
        >
            <div className="cell-content-wrapper">
                <div className="cell-content">
                    {
                        arrivalTimeFromNowText && arrivalTimeText ?
                            <React.Fragment>
                                {arrivalTimeFromNowText} ({arrivalTimeText})
                            </React.Fragment>
                            :
                            null
                    }
                </div>
            </div>
        </TableCell>
    );
}